
import { computed, ComputedRef, Ref } from "@vue/reactivity";
import { defineComponent, onBeforeMount, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { toPercentage } from "../../../../presentation/components/mixins";
import { updateQueries, removeQueries } from "../../../utils/routing_utils";

/** A th that when clicked updates the query param passed
 * by props (orderBy) to one of the three states: ASC, DESC, Disabled. */
const __default__ = defineComponent({
  props: {
    /** Text that will display in the <th> and in the title attribute. */
    text: {
      type: String,
      default: "",
    },
    /** The attribute that will be the value of the orderBy query param
     * when the order is enabled. */
    orderBy: {
      type: String,
      default: "",
    },
    /** String in the format number1/number2 where number1 is the amount
     * of  spaces that this column will occupy and number2 the total
     * amount of spaces that the table has */
    space: {
      type: String,
      default: "",
    },
    alignment: {
      type: String,
      default: "center",
    },
  },
  setup(props) {
    /** An instance of Router. */
    const router = useRouter();

    /** An instance of Router. */
    const route = useRoute();

    /** Width of the th. */
    const width: Ref<string> = ref("initial");

    enum OrderState {
      Inactive,
      Asc,
      Desc,
    }

    /** Current state of the column order. */
    const currentState: Ref<OrderState> = ref(OrderState.Inactive);

    /** The class containing the style of the current order. */
    const orderClass: ComputedRef<
      "desc" | "disabled" | "asc" | undefined
    > = computed(() => {
      if (route.query.orderBy !== props.orderBy) {
        currentState.value = OrderState.Inactive;
        return "disabled";
      }

      switch (OrderState[String(route.query.order)]) {
        case OrderState.Inactive:
          return "disabled";
        case OrderState.Asc:
          return "asc";
        case OrderState.Desc:
          return "desc";
      }

      return;
    });

    onBeforeMount(async () => {
      if (props.space) {
        width.value = `${toPercentage(
          Number(props.space.split("/")[0]),
          Number(props.space.split("/")[1])
        ).toString()}%`;
      }

      currentState.value = OrderState[String(route.query.order)];
    });

    /** Updates the URL with a new order. */
    const changeOrder = async (): Promise<void> => {
      switch (currentState.value) {
        case OrderState.Inactive:
          currentState.value = OrderState.Asc;
          break;
        case OrderState.Asc:
          currentState.value = OrderState.Desc;
          break;
        case OrderState.Desc:
          currentState.value = OrderState.Inactive;
          await removeQueries(router, ["orderBy", "order"]);
          return;
      }

      await updateQueries(router, {
        orderBy: props.orderBy,
        order: OrderState[currentState.value].toString(),
      });
    };

    return {
      changeOrder,
      orderClass,
      width,
    };
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "3b6e1308": (_ctx.alignment),
  "3e14f96b": (_ctx.width)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__